import {
  applyMiddleware,
  compose,
  legacy_createStore as createStore,
} from 'redux'
import { thunk } from 'redux-thunk'

import reducer from './rootReducer'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(reducer, composeEnhancers(applyMiddleware(thunk)))

export default store
